import { useSearch } from "@tanstack/react-router";
import { useGetOutgoingPostbackQuery } from "api/TenantSlug/OutgoingPostback/hooks.ts";
import { ModifyPostbackOutgoingMethodsForm } from "components/Forms/ModifyPostbackOutgoingMethodsForm/ModifyPostbackOutgoingMethodsForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface SearchParams {
    [`modifyPostbackOutgoingMethods-id`]: string;
}

export const ModifyPostbackOutgoingMethodsDrawer: FC = () => {
    const drawerId = DrawerId.ModifyPostbackOutgoingMethods;
    const drawerUtils = useDrawer();

    const searchParams = useSearch({ strict: false }) as SearchParams;
    const outgoingPostbackId = searchParams[`${drawerId}-id`];
    const getOutgoingPostbackQuery = useGetOutgoingPostbackQuery(outgoingPostbackId, {});

    if (
        getOutgoingPostbackQuery.isLoading ||
        getOutgoingPostbackQuery.isFetching ||
        !getOutgoingPostbackQuery.data?.outgoingPostback
    ) {
        return <></>;
    }

    const outgoingPostback = getOutgoingPostbackQuery.data.outgoingPostback;

    return (
        <Drawer drawerId={drawerId} title={<DrawerTitle mainTitle={"Metody"} subTitles={[outgoingPostback.name]} />}>
            <ModifyPostbackOutgoingMethodsForm
                onClose={() => drawerUtils.hide(drawerId)}
                outgoingPostback={outgoingPostback}
            />
        </Drawer>
    );
};
